import { render, staticRenderFns } from "./communicationDashboardSlideManager.vue?vue&type=template&id=f98683d4&scoped=true"
import script from "./communicationDashboardSlideManager.vue?vue&type=script&lang=js"
export * from "./communicationDashboardSlideManager.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardSlideManager.vue?vue&type=style&index=0&id=f98683d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98683d4",
  null
  
)

export default component.exports